export default __webpack_public_path__ + "a1302f4854a6e7c683e6950bc1e323a5.png";